export default {"src":"/_next/static/media/quality.591860af.svg","height":31,"width":32};